export default "__VITE_ASSET__DdxI3wSa__"